<template>
  <div class="home-bookList" :style="{ background: `url(${bg})` }">
    <div class="w-main">
      <el-carousel trigger="click" height="600px">
        <el-carousel-item v-for="(item, index) in bookData" :key="index">
          <div class="swipe-box">
            <div
              class="itemImg"
              v-for="(el, _index) in item"
              :key="_index"
              @click="show"
            >
              <img :src="el" alt />
            </div>
          </div>
        </el-carousel-item>
      </el-carousel>
    </div>
    <homeCode v-if="dadilogType" @hide="hidedadilog" />
  </div>
</template>

<script>
import bg from "@/assets/img/home/bg.png";
import { getIndexMagazineList } from "@/api/api.js";
import homeCode from "@/components/pc/home/homeCode.vue";

export default {
  name: "pcHomeAbout",
  data() {
    return {
      bg,
      dadilogType: false,
      bookData: []
    };
  },
  components: {
    homeCode
  },
  mounted() {
    this.getIndexMagazineList();
  },
  methods: {
    getIndexMagazineList() {
      getIndexMagazineList().then(res => {
        if (res.code === 0) {
          this.setData(res.data);
        } else {
          this.$message({
            message: res.msg,
            type: "error"
          });
        }
      });
    },
    hidedadilog() {
      this.dadilogType = false;
    },
    show() {
      this.dadilogType = true;
    },
    setData(data) {
      this.bookData = [];
      let _index = 0;
      data.forEach((el, index) => {
        if (index % 4 === 0 && index !== 0) {
          this.bookData.push(data.slice(_index, index));
          _index = index;
        }
        if (index + 1 === data.length) {
          this.bookData.push(data.slice(_index, index + 1));
        }
      });
    }
  }
};
</script>

<style lang="less">
.home-bookList {
  width: 100%;
  min-width: 1200px;
  height: 600px;
  box-sizing: border-box;
  .swipe-box {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 100%;
    .itemImg {
      width: 277px;
      height: 397px;
      // 277px*397px
      overflow: hidden;
      cursor: pointer;
    }
  }
}
</style>
